import React, { Component } from 'react';

const DownloadURL = () => (

	<div style={ styles.container }>

		<img style={styles.logo} src={require('../logo.png')} />
		<p style={styles.subtitle}>
		Where Fun and Family Come Together
		</p>

		<a href='https://apple.co/2CVUdYb'>
			<img style={styles.images} src={require('../images/downloadAppStore.png')} />
		</a>

		<a href='https://bit.ly/androidFunily'>
			<img style={styles.images} src={require('../images/downloadGooglePlay.png')} />
		</a>

		<img style={styles.qr} src={require('../images/FunDownloadQR.png')} />
	</div>

)

const width = window.innerWidth;
const height= window.screen.height;

const styles = {
	container: {
		height: height,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start'
	},
	logo: {
		height: width * .25,
		width: width * .25,
		borderRadius: width * .01,
		marginTop: width * .03,
		marginBottom: width * .05,
	},
	subtitle: {
		color: '#3748ac',
		fontSize: width * .04
	},
	images: {
		height: width * .15,
		width: width * .5,
		margin: width * .05
	},
	qr: {
		marginTop: width * .03,
		marginBottom: width * .05,
	}
}

export default DownloadURL;



// WEBPACK FOOTER //
// ./src/components/DownloadURL.js